
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[storeSlug]/cart",
      function () {
        return require("private-next-pages/store/[storeSlug]/cart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[storeSlug]/cart"])
      });
    }
  